import { REGIONI } from '../utils/geoItalia';

const TIPI_SPEDIZIONE = [
  { value: 'fresco', label: 'Fresco (refrigerato)' },
  { value: 'secco', label: 'Secco' },
  { value: 'fragile', label: 'Fragile' },
];

/**
 * Campi minimi dataset prodotto (logistica + produzione).
 * adminMode: l'admin può modificare anche i costi di produzione.
 */
export default function ProdottoDatasetForm({ values, onChange, adminMode = false, compact = false, partners = [] }) {
  const set = (field, val) => onChange({ ...values, [field]: val });

  const col = compact ? 'col-md-6' : 'col-md-4';

  return (
    <div className="row g-3">
      <div className={col}>
        <label className="form-label">Quantità giornaliera *</label>
        <input
          type="number"
          min={1}
          className="form-control"
          required
          value={values.capacita_giornaliera ?? ''}
          onChange={(e) => set('capacita_giornaliera', e.target.value)}
        />
      </div>
      <div className={col}>
        <label className="form-label">Preavviso produzione (giorni) *</label>
        <input
          type="number"
          min={0}
          max={365}
          className="form-control"
          required
          value={values.tempoPreavviso ?? ''}
          onChange={(e) => set('tempoPreavviso', e.target.value)}
        />
      </div>
      <div className={col}>
        <label className="form-label">Max ore trasporto *</label>
        <input
          type="number"
          min={1}
          max={72}
          className="form-control"
          required
          value={values.ore_max_trasporto ?? ''}
          onChange={(e) => set('ore_max_trasporto', e.target.value)}
        />
      </div>
      <div className={col}>
        <label className="form-label">Tipo spedizione *</label>
        <select
          className="form-select"
          required
          value={values.tipo_spedizione || ''}
          onChange={(e) => set('tipo_spedizione', e.target.value)}
        >
          <option value="">— Seleziona —</option>
          {TIPI_SPEDIZIONE.map((t) => (
            <option key={t.value} value={t.value}>{t.label}</option>
          ))}
        </select>
      </div>
      <div className="col-md-6">
        <label className="form-label">Regioni pickup (partenza)</label>
        <select multiple className="form-select" style={{ height: 90 }}
          value={values.regioni_pickup || []}
          onChange={(e) => set('regioni_pickup', Array.from(e.target.selectedOptions, o => o.value))}>
          {REGIONI.map(r => <option key={r.id} value={r.id}>{r.nome}</option>)}
        </select>
        <div className="form-text">Nessuna = calcolo automatico da coordinate</div>
      </div>
      <div className="col-md-6">
        <label className="form-label">Regioni consegna</label>
        <select multiple className="form-select" style={{ height: 90 }}
          value={values.regioni_consegna || []}
          onChange={(e) => set('regioni_consegna', Array.from(e.target.selectedOptions, o => o.value))}>
          {REGIONI.map(r => <option key={r.id} value={r.id}>{r.nome}</option>)}
        </select>
        <div className="form-text">Nessuna = nessun limite</div>
      </div>
      {adminMode && (
        <>
          <div className={col}>
            <label className="form-label">Costo produzione proposto (€)</label>
            <input
              type="number"
              step="0.01"
              min="0.01"
              className="form-control"
              value={values.costoProduzione ?? ''}
              onChange={(e) => set('costoProduzione', e.target.value)}
            />
          </div>
          <div className={col}>
            <label className="form-label">Costo concordato (€) *</label>
            <input
              type="number"
              step="0.01"
              min="0.01"
              className="form-control"
              value={values.costo_produzione_concordato ?? ''}
              onChange={(e) => set('costo_produzione_concordato', e.target.value)}
            />
            <small className="text-muted">Valore usato per ordini e catalogo</small>
          </div>
          <div className={col}>
            <label className="form-label">IVA prodotto (override)</label>
            <select
              className="form-select"
              value={values.aliquota_iva ?? ''}
              onChange={(e) => set('aliquota_iva', e.target.value)}
            >
              <option value="">Da categoria</option>
              <option value="4">4%</option>
              <option value="10">10%</option>
              <option value="22">22%</option>
            </select>
          </div>
        </>
      )}
      <div className="col-12">
        <label className="form-label">Note spedizione</label>
        <textarea
          className="form-control"
          rows={2}
          value={values.note_spedizione || ''}
          onChange={(e) => set('note_spedizione', e.target.value)}
          placeholder="Es. catena del freddo, non inclinare…"
        />
      </div>
    </div>
  );
}

export function datasetFormFromProdotto(p = {}) {
  return {
    capacita_giornaliera: p.capacita_giornaliera ?? p.produzioneGiornaliera ?? '',
    tempoPreavviso: p.tempoPreavviso ?? '',
    ore_max_trasporto: p.ore_max_trasporto ?? '',
    tipo_spedizione: p.tipo_spedizione ?? '',
    note_spedizione: p.note_spedizione ?? '',
    costoProduzione: p.costoProduzione ?? '',
    costo_produzione_concordato: p.costo_produzione_concordato ?? p.costoProduzione ?? '',
    aliquota_iva: p.aliquota_iva ?? '',
    regioni_pickup: p.regioni_pickup || [],
    regioni_consegna: p.regioni_consegna || [],
    partner_trasporto_predefinito_id: p.partner_trasporto_predefinito_id || '',
  };
}

export function payloadFromDatasetForm(form) {
  const cap = form.capacita_giornaliera === '' ? null : parseInt(form.capacita_giornaliera, 10);
  return {
    capacita_giornaliera: cap,
    produzioneGiornaliera: cap,
    tempoPreavviso: form.tempoPreavviso === '' ? null : parseInt(form.tempoPreavviso, 10),
    ore_max_trasporto: form.ore_max_trasporto === '' ? null : parseInt(form.ore_max_trasporto, 10),
    tipo_spedizione: form.tipo_spedizione || null,
    note_spedizione: form.note_spedizione || null,
    costoProduzione: form.costoProduzione === '' ? undefined : parseFloat(form.costoProduzione),
    costo_produzione_concordato: form.costo_produzione_concordato === ''
      ? undefined
      : parseFloat(form.costo_produzione_concordato),
    aliquota_iva: form.aliquota_iva === '' || form.aliquota_iva == null
      ? null
      : parseFloat(form.aliquota_iva),
    regioni_pickup: form.regioni_pickup || [],
    regioni_consegna: form.regioni_consegna || [],
    partner_trasporto_predefinito_id: form.partner_trasporto_predefinito_id || null,
  };
}
